import React from "react";
import { Map, Calendar, Menu, MessageCircle, Play, Square, Coffee } from "lucide-react";

const NavBtn = ({ icon: Icon, label, active, onClick, accent }) => (
  <button
    type="button"
    onClick={onClick}
    className={`flex flex-col items-center justify-center flex-1 min-w-0 py-1 gap-0.5 ${
      active ? "text-teal-400" : accent || "text-slate-400"
    }`}
  >
    <Icon size={20} strokeWidth={active ? 2.2 : 1.75} />
    <span className="text-[9px] font-medium truncate max-w-full px-0.5">{label}</span>
  </button>
);

const MobileBottomNav = ({
  activeTab,
  onTabChange,
  shiftState,
  onShiftToggle,
  onBreak,
  onChat,
}) => {
  const working = shiftState === "working";
  const onBreakActive = shiftState === "break";

  return (
    <nav className="shrink-0 h-16 bg-slate-900 border-t border-slate-800 flex items-stretch safe-area-pb z-50">
      <NavBtn icon={Menu} label="Menu" active={activeTab === "menu"} onClick={() => onTabChange("menu")} />
      <NavBtn icon={Map} label="Terkep" active={activeTab === "map"} onClick={() => onTabChange("map")} />
      <NavBtn icon={Calendar} label="Naptar" active={activeTab === "calendar"} onClick={() => onTabChange("calendar")} />
      <button
        type="button"
        onClick={onShiftToggle}
        className={`flex flex-col items-center justify-center flex-1 min-w-0 py-1 gap-0.5 ${
          working ? "text-emerald-400" : "text-slate-400"
        }`}
      >
        {working ? <Square size={20} /> : <Play size={20} />}
        <span className="text-[9px] font-medium">{working ? "Stop" : "Start"}</span>
      </button>
      <button
        type="button"
        onClick={onBreak}
        className={`flex flex-col items-center justify-center flex-1 min-w-0 py-1 gap-0.5 ${
          onBreakActive ? "text-amber-400" : "text-slate-400"
        }`}
      >
        <Coffee size={20} />
        <span className="text-[9px] font-medium">Break</span>
      </button>
      <NavBtn icon={MessageCircle} label="Chat" active={activeTab === "chat"} onClick={onChat} accent="text-slate-300" />
    </nav>
  );
};

export default MobileBottomNav;
